// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3L0MM","left":"styles_left__sgbHe","desktopActions":"styles_desktopActions__3DBW2","title":"styles_title__1-nBW"};